import http from "../../http-common";

const getFees = async (query) => {
  return await http
    .get("/admin/fees", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const saveFees = async (fees) => {
  return await http.post("/admin/fees", fees)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getFees,
  saveFees,
};
